// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3-K8z","description":"PatientConsentPreview_description__3DS8U"};